module.exports = __webpack_public_path__ + "static/img/base_4.e8ce959.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/base_4.jpg
// module id = 1VG3
// module chunks = 1